/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import { BadgeCheck, CalendarRange, CircleAlert, RefreshCw, ShieldAlert } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j05-s04-declarar-aptidao';
export function AptidaoRecursosPage() {
  const [s, setS] = useState<any>(),
    [busy, setBusy] = useState(''),
    keys = useRef(new Map<string, string>());
  async function call(path: string, body?: unknown) {
    setBusy(path);
    try {
      const x = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo: body,
      });
      setS(x.state);
    } finally {
      setBusy('');
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Calculando aptidão operacional…
      </main>
    );
  return (
    <main className="min-w-0 w-full max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <p className="text-sm text-muted-foreground">J-05 · Frota e equipe</p>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {s.alertas?.map((a: any, i: number) => (
        <div key={i} role="alert" className="rounded-md border border-destructive p-3">
          <CircleAlert className="mr-2 inline h-5 w-5" />
          {a.mensagem}
        </div>
      ))}
      <section aria-label="Recursos para aptidão" className="space-y-3">
        {s.recursos.length === 0 ? (
          <p className="rounded-md border p-5">Nenhum recurso está disponível para cálculo.</p>
        ) : (
          s.recursos.map((r: any) => {
            const c = r.calculo,
              a = r.aptidao,
              k = `${r.recursoTipo}:${r.recursoId}`;
            return (
              <article key={k} className="rounded-md border p-4">
                <h2 className="font-semibold">
                  <BadgeCheck className="mr-2 inline h-5 w-5" />
                  {r.recursoTipo} · {r.identificador}
                </h2>
                <p>
                  Elegível agora: {c.elegivel ? 'sim' : 'não'} · documentos {c.documentosValidos}/
                  {c.documentosTotal} · vínculo {c.vinculoVigente ? 'vigente' : 'pendente'}
                </p>
                <p>
                  <CalendarRange className="mr-1 inline h-4 w-4" />
                  Período calculado: {c.inicio ?? '—'} até {c.validadeLimite ?? '—'}
                </p>
                <p>
                  Status operacional: <strong>{a?.status ?? 'NÃO DECLARADO'}</strong>
                  {a?.motivo ? ` — ${a.motivo}` : ''}
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {c.elegivel && a?.status !== 'APTO' && (
                    <Button
                      disabled={!!busy}
                      onClick={() => {
                        const x = keys.current.get(k) ?? crypto.randomUUID();
                        keys.current.set(k, x);
                        void call('/verbs/confirmar_aptidao', {
                          recursoTipo: r.recursoTipo,
                          recursoId: r.recursoId,
                          chaveIdempotencia: x,
                        });
                      }}
                    >
                      Confirmar aptidão
                    </Button>
                  )}
                  <Button
                    variant="outline"
                    disabled={!!busy}
                    onClick={() =>
                      void call('/verbs/recalcular', {
                        recursoTipo: r.recursoTipo,
                        recursoId: r.recursoId,
                      })
                    }
                  >
                    <RefreshCw className="mr-2 h-4 w-4" />
                    Recalcular
                  </Button>
                  {a?.status === 'APTO' && (
                    <Button
                      variant="outline"
                      disabled={!!busy}
                      onClick={() =>
                        void call('/verbs/registrar_conflito', {
                          recursoTipo: r.recursoTipo,
                          recursoId: r.recursoId,
                          motivo: 'Conflito operacional confirmado pelo DTP durante a alocação.',
                        })
                      }
                    >
                      <ShieldAlert className="mr-2 h-4 w-4" />
                      Registrar conflito
                    </Button>
                  )}
                </div>
              </article>
            );
          })
        )}
      </section>
    </main>
  );
}
